<div class="container mt-8">
  <div class="grid grid-cols-1">
    <div class="relative overflow-hidden lg:px-8 px-6 py-10 mb-20 rounded-xl shadow-lg dark:shadow-gray-700" [innerHTML]="disc?.omschrijving | mdtohtml">
    </div>
  </div>
</div>

<div class="container">
  <h3 class="text-xl font-semibold text-black/70 mt-2">Specialisaties binnen {{disc?.naam | lowercase}}</h3>

  <div class="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[30px] mt-12 mb-12">

    <app-specialisatie-card *ngFor="let spec of specs" [spec]="spec"></app-specialisatie-card>

  </div>
</div>

